module.exports = __webpack_public_path__ + "img/pic_card@3x.1597aa23.png";